import { CoordinatorService } from './coordinator.service';
import { Table } from './table';
import { TableRowInstance } from './table-row-instance';

export type TABLE_TYPE = 'general' | 'biblio';

export class TableInstance {
    private _rowLs: TableRowInstance[] = [];
    private _isEditOn = false;

    isEditable = true;
    isAutoconfirm = false;

    focusRow: TableRowInstance | undefined;

    constructor(
        private coords: CoordinatorService,
        public tbl: Table,
        public input: any,
    ) {
        this._rowLs = this.tbl.rowLs.map((r) => new TableRowInstance(this.coords, this, r));
    }

    copy(input?: any) {
        if (!input) input = this.input;
        const tbli = new TableInstance(this.coords, this.tbl, input);
        return tbli;
    }

    submitIsDisabled(tp: TABLE_TYPE) {
        for (const r of this._rowLs) if (r.submitIsDisabled()) return true;

        return false;
    }

    rowLs(
        params: {
            onlyPinnedRows?: boolean;
            hideEmpty?: boolean;
        } = {},
    ) {
        let ls = this._rowLs;
        if (!this.isEditOn) ls = ls.filter((tblri) => !tblri.inEditOnly);

        if (params.hideEmpty || (this.tbl.hideEmpty && !this.isEditOn))
            ls = ls.filter((tblri) => !tblri.isEmpty);
        if (params.onlyPinnedRows) ls = ls.filter((r) => r.hasPin);
        return ls;
    }

    private _exportParams() {
        const ls = this._rowLs.map((r) => r.exportParams());
        return {
            headerLs: ['Field', 'Value'].map((x) => this.coords.text(x)),
            rowLs: ls,
        };
    }

    getCell(row: string) {
        for (const r of this._rowLs) {
            const c = r.getCell(row);
            if (c) return c;
        }
        return undefined;
    }

    export(isPartial = false) {
        alert('EXPORT TO LOADABLE TO BE IMPLEMENTED');
    }

    getCellsData() {
        const data: { tag: string; value: string }[] = this._rowLs.map((row) => {
            return { tag: row.cellLs[0].tc.tag, value: row.cellLs[0].value };
        });
        return data;
    }

    getCellValue(tag: string) {
        for (let r of this._rowLs) {
            for (let c of r.cellLs) {
                if (c.tc.tag == tag) return c;
            }
        }
        return undefined;
    }

    csv(isPartial = false) {
        this.coords.export$.csv(this._exportParams());
    }

    html(isPartial = false) {
        this.coords.export$.html(this._exportParams());
    }

    docx() {
        return this._exportParams();
    }

    edit(params?: { focusRow?: TableRowInstance }) {
        if (!this.isEditable) return;
        this.isEditOn = true;
        this.focusRow = params?.focusRow;
        this.coords.display$.markForCheck();
    }

    cancelEdit() {
        this.isEditOn = false;
        this.coords.display$.markForCheck();
    }

    submitEdit() {
        this.confirmChanges();
    }

    async confirmChanges() {
        this._rowLs.forEach((r) => r.confirmChanges());
        if (this.input.afterConfirmChanges) await this.input.afterConfirmChanges();
        else this.input.markForManifestStore();
        this.isEditOn = false;
        this.coords.display$.markForCheck();
    }

    public get isEditOn(): boolean {
        return this._isEditOn;
    }
    public set isEditOn(value: boolean) {
        this._isEditOn = value;
        value && this._rowLs.forEach((r) => r.initEdit());
        this.coords.display$.markForCheck();
    }

    get isGlobalEdit() {
        return this.tbl.isGlobalEdit;
    }

    get hasPin() {
        return !!this.tbl.pin;
    }
}
